import React from "react";
import { PARAM_TIPOS_CATALOGO } from "./parametrosTipoConfig";
import EvtTipoTabLabel from "./EvtTipoTabLabel";

export default function EvtParametrosTipoTabs({
  value,
  onChange,
  items = PARAM_TIPOS_CATALOGO,
}) {
  if (!items.length) return null;

  const isSingle = items.length === 1;
  const isOddCount = !isSingle && items.length % 2 === 1;

  return (
    <div
      className={`evt-efectos-tabs evt-efectos-tabs--param${
        isSingle ? " is-single-tab" : ""
      }${items.length >= 3 ? " is-many-tabs" : ""}${
        isOddCount ? " is-odd-count" : ""
      }`}
      role="tablist"
      aria-label="Tipo de producto eruptivo"
    >
      {items.map((item, index) => {
        const isActive = value === item.label;

        return (
          <React.Fragment key={item.label}>
            {index > 0 ? (
              <span className="evt-efectos-tab-divider" aria-hidden="true" />
            ) : null}
            <button
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`evt-efectos-tab${isActive ? " is-active" : ""}`}
              onClick={() => onChange(item.label)}
            >
              <span className="evt-efectos-tab__icon-wrap" aria-hidden="true">
                <img className="evt-efectos-tab__icon" src={item.icon} alt="" />
              </span>
              <EvtTipoTabLabel label={item.label} forceSingleLine={isSingle} />
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}
